import React from "react";
import { useAppMeta } from "hooks";
import { useNavigate, useParams } from "react-router-dom";
import { toast } from "react-toastify";
import { useGetVehicleFuelDetailQuery, useUpdateVehicleFuelMutation } from "store/services/vehicleFuelApi";

import BreadcrumbLayout from "layouts/BreadcrumbLayout";
import VehicleFuelForm from "./VehicleFuelComponents/VehicleFuelForm";

const VehicleFuelEditScreen = () => {
  const { id } = useParams();
  const navigate = useNavigate();

  const breadcrumbs = [
    { title: "Vehicle Fuel", path: "/app/crm/vehicle-fuel/list" },
    { title: "Edit Vehicle Fuel" },
  ];

  // RTK Query
  const {
    data: vehicleFuelDetails,
    isLoading: loadingVehicleFuel,
    error,
  } = useGetVehicleFuelDetailQuery(id);

  const [updateVehicleFuel, { isLoading: updatingVehicleFuel }] = useUpdateVehicleFuelMutation();

  // Methods
  const handleUpdateVehicleFuel = async (data) => {
    const _payload = data;

    delete _payload.disclaimers;
    try {
      await updateVehicleFuel({ _id: id, ..._payload }).unwrap();
      toast.success("Vehicle Fuel successfully updated!");
      navigate(`/app/crm/vehicle-fuel/${id}/detail`);
    } catch (err) {
      toast.error(
        err?.data?.message ?? err?.message ?? "Couldn't update Vehicle Fuel!"
      );
    }
  };

  useAppMeta("Edit Vehicle Fuel");

  return (
    <BreadcrumbLayout
      breadcrumbs={breadcrumbs}
      isBusy={loadingVehicleFuel || updatingVehicleFuel}
    >
      <BreadcrumbLayout.Error error={error} />
      <BreadcrumbLayout.Paper>
        <VehicleFuelForm
          isBusy={loadingVehicleFuel || updatingVehicleFuel}
          vehicleFuelDetail={vehicleFuelDetails}
          onSubmit={handleUpdateVehicleFuel}
        />
      </BreadcrumbLayout.Paper>
    </BreadcrumbLayout>
  );
};

export default VehicleFuelEditScreen;